function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => {
    if (video.closest('.floating-logo')) {
      if (video.paused) video.play().catch(() => {});
      return;
    }
    video.pause();
  });
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));

    // Add hover events for desktop flyout submenus
    this.bindHoverEvents();
  }

  bindHoverEvents() {
    // Get all details elements that have submenus (all levels)
    // Level 2: .menu-drawer__menu.has-submenu > li > details
    // Level 3: .menu-drawer__inner-submenu .menu-drawer__menu li > details
    const allDetailsWithSubmenu = this.querySelectorAll('.menu-drawer__menu.has-submenu > li > details, .menu-drawer__inner-submenu .menu-drawer__menu li > details');

    allDetailsWithSubmenu.forEach(details => {
      const parentLi = details.parentElement;

      parentLi.addEventListener('mouseenter', (e) => {
        // Only apply hover behavior on desktop (> 990px)
        if (window.innerWidth > 990) {
          details.setAttribute('open', '');
          details.classList.add('menu-opening');
        }
      });

      parentLi.addEventListener('mouseleave', (e) => {
        // Only apply hover behavior on desktop
        if (window.innerWidth > 990) {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        }
      });
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    // Listen for clicks outside the drawer to close it
    setTimeout(() => {
      this._onDocumentClick = this._onDocumentClick || ((evt) => {
        if (!this.mainDetailsToggle.hasAttribute('open')) return;
        // Close if click is outside the drawer panel and not on the summary toggle
        const drawer = this.mainDetailsToggle.querySelector('.menu-drawer');
        const summary = this.mainDetailsToggle.querySelector('summary');
        if (drawer && !drawer.contains(evt.target) && !summary.contains(evt.target)) {
          this.closeMenuDrawer(evt, summary);
        }
      });
      document.addEventListener('click', this._onDocumentClick);
    });

    // Close on mouseleave (desktop only)
    this.bindDrawerMouseLeave();
  }

  bindDrawerMouseLeave() {
    const drawer = this.mainDetailsToggle.querySelector('.menu-drawer');
    if (!drawer) return;

    this._drawerMouseLeave = () => {
      if (window.innerWidth <= 990) return;
      this._mouseLeaveTimeout = setTimeout(() => {
        const summary = this.mainDetailsToggle.querySelector('summary');
        this.closeMenuDrawer(new Event('mouseleave'), summary);
      }, 400);
    };

    this._drawerMouseEnter = () => {
      if (this._mouseLeaveTimeout) {
        clearTimeout(this._mouseLeaveTimeout);
        this._mouseLeaveTimeout = null;
      }
    };

    drawer.addEventListener('mouseleave', this._drawerMouseLeave);
    drawer.addEventListener('mouseenter', this._drawerMouseEnter);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    // Remove the outside-click listener
    if (this._onDocumentClick) {
      document.removeEventListener('click', this._onDocumentClick);
    }

    // Clean up mouseleave listeners
    if (this._mouseLeaveTimeout) {
      clearTimeout(this._mouseLeaveTimeout);
      this._mouseLeaveTimeout = null;
    }
    const drawer = this.mainDetailsToggle.querySelector('.menu-drawer');
    if (drawer && this._drawerMouseLeave) {
      drawer.removeEventListener('mouseleave', this._drawerMouseLeave);
      drawer.removeEventListener('mouseenter', this._drawerMouseEnter);
    }

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 500) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset ||
      (this.closest('.header-wrapper')?.classList.contains('header-wrapper--border-bottom') ? 1 : 0);
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    // Ensure header is visible when menu opens
    this.header.classList.remove('shopify-section-header-hidden', 'animate');
    this.header.style.transform = 'none';
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    // Listen for clicks outside the drawer to close it
    setTimeout(() => {
      this._onDocumentClick = this._onDocumentClick || ((evt) => {
        if (!this.mainDetailsToggle.hasAttribute('open')) return;
        const drawer = this.mainDetailsToggle.querySelector('.menu-drawer');
        const summary = this.mainDetailsToggle.querySelector('summary');
        if (drawer && !drawer.contains(evt.target) && !summary.contains(evt.target)) {
          this.closeMenuDrawer(evt, summary);
        }
      });
      document.addEventListener('click', this._onDocumentClick);
    });
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

// Desktop hover-to-open for nested menu items
// Native <details> elements require [open] attribute - CSS hover alone won't work
if (window.matchMedia('(min-width: 990px)').matches) {
  document.addEventListener('DOMContentLoaded', () => {
    const menuDrawer = document.querySelector('menu-drawer');
    if (!menuDrawer) return;

    // Handle hover on nested details inside the menu drawer
    menuDrawer.querySelectorAll('.menu-drawer__inner-submenu .menu-drawer__menu > li').forEach(li => {
      const details = li.querySelector(':scope > details');
      if (!details) return;

      li.addEventListener('mouseenter', () => {
        details.setAttribute('open', '');
      });

      li.addEventListener('mouseleave', () => {
        details.removeAttribute('open');
      });
    });
  });
}

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Batch all layout reads before any writes to avoid forced reflow on scroll.
    const sliderScrollLeft = this.slider.scrollLeft;
    const sliderClientWidth = this.slider.clientWidth;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(sliderScrollLeft / this.sliderItemOffset) + 1;

    let firstSlideVisible, lastSlideVisible;
    if (!this.enableSliderLooping) {
      const firstSlide = this.sliderItemsToShow[0];
      const lastSlide = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
      firstSlideVisible = this._isSlideVisibleWithMetrics(firstSlide, sliderScrollLeft, sliderClientWidth);
      lastSlideVisible = this._isSlideVisibleWithMetrics(lastSlide, sliderScrollLeft, sliderClientWidth);
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (firstSlideVisible && sliderScrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (lastSlideVisible) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  _isSlideVisibleWithMetrics(element, sliderScrollLeft, sliderClientWidth, offset = 0) {
    const lastVisibleSlide = sliderClientWidth + sliderScrollLeft - offset;
    const elementOffsetLeft = element.offsetLeft;
    return (elementOffsetLeft + element.clientWidth) <= lastVisibleSlide && elementOffsetLeft >= sliderScrollLeft;
  }

  isSlideVisible(element, offset = 0) {
    return this._isSlideVisibleWithMetrics(element, this.slider.scrollLeft, this.slider.clientWidth, offset);
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class ClienteleSlideshow extends HTMLElement {
  constructor() {
    super();
    this.slides = Array.from(this.querySelectorAll('.appointment-cta__slide'));
    this.captions = Array.from(this.querySelectorAll('.appointment-cta__caption-item'));
    this.dots = Array.from(this.querySelectorAll('.appointment-cta__dot'));
    this.stage = this.querySelector('.appointment-cta__stage');
    this.prevBtn = this.querySelector('.appointment-cta__nav--prev');
    this.nextBtn = this.querySelector('.appointment-cta__nav--next');
    this.swipeHint = this.querySelector('.appointment-cta__swipe-hint');
    this.current = 0;
    this.total = this.slides.length;
    this.speed = (parseFloat(this.dataset.speed) || 3.5) * 1000;
    this.positions = ['is-far-prev', 'is-prev', 'is-active', 'is-next', 'is-far-next'];

    if (this.total < 2) return;

    this.arrange();

    // Dot click navigation
    this.dots.forEach(dot => {
      dot.addEventListener('click', () => {
        this.current = parseInt(dot.dataset.index);
        this.arrange();
        this.play();
      });
    });

    // Arrow navigation
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.prev();
        this.play();
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.next();
        this.play();
      });
    }

    // Mouse tilt on the card stage
    if (this.stage) {
      this.stage.addEventListener('mouseenter', () => { this._stageRect = this.stage.getBoundingClientRect(); });
      this.stage.addEventListener('mousemove', (e) => this.handleTilt(e));
      this.stage.addEventListener('mouseleave', () => { this._stageRect = null; this.resetTilt(); });
      // Store bound refs so disconnectedCallback can remove these window-level
      // listeners (they'd otherwise leak when the section is re-rendered in the
      // theme editor or removed from the DOM).
      this._clearStageRect = () => { this._stageRect = null; };
      window.addEventListener('scroll', this._clearStageRect, { passive: true });
      window.addEventListener('resize', this._clearStageRect);
    }

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.play());

    // Swipe / drag support
    this.swipeStartX = 0;
    this.swipeStartY = 0;
    this.isDragging = false;

    // Touch
    this.addEventListener('touchstart', (e) => {
      this.swipeStartX = e.touches[0].clientX;
      this.swipeStartY = e.touches[0].clientY;
    }, { passive: true });
    this.addEventListener('touchend', (e) => {
      this.handleSwipeEnd(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
    }, { passive: true });

    // Mouse drag
    this.addEventListener('mousedown', (e) => {
      this.isDragging = true;
      this.swipeStartX = e.clientX;
      this.swipeStartY = e.clientY;
    });
    this.addEventListener('mouseup', (e) => {
      if (this.isDragging) {
        this.isDragging = false;
        this.handleSwipeEnd(e.clientX, e.clientY);
      }
    });
    this.addEventListener('mouseleave', () => {
      this.isDragging = false;
    });

    // Click-through navigation on cards
    this.slides.forEach((slide, idx) => {
      slide.style.cursor = 'pointer';
      slide.addEventListener('click', (e) => {
        const dx = Math.abs(e.clientX - this.swipeStartX);
        const dy = Math.abs(e.clientY - this.swipeStartY);
        if (dx > 5 || dy > 5) return;
        if (slide.classList.contains('is-prev') || slide.classList.contains('is-far-prev')) {
          this.prev();
        } else {
          this.current = idx;
          this.arrange();
        }
        this.play();
      });
    });

    // Start autoplay
    this.play();
  }

  getIndex(offset) {
    return ((this.current + offset) % this.total + this.total) % this.total;
  }

  arrange() {
    this.slides.forEach(s => {
      this.positions.forEach(p => s.classList.remove(p));
      s.classList.remove('is-active');
      s.style.transform = '';
    });
    this.captions.forEach(c => c.classList.remove('is-active'));
    this.dots.forEach(d => d.classList.remove('is-active'));

    this.slides[this.getIndex(-2)].classList.add('is-far-prev');
    this.slides[this.getIndex(-1)].classList.add('is-prev');
    this.slides[this.current].classList.add('is-active');
    this.slides[this.getIndex(1)].classList.add('is-next');
    this.slides[this.getIndex(2)].classList.add('is-far-next');

    if (this.captions[this.current]) this.captions[this.current].classList.add('is-active');
    if (this.dots[this.current]) this.dots[this.current].classList.add('is-active');
  }

  handleTilt(e) {
    const active = this.slides.find(s => s.classList.contains('is-active'));
    if (!active) return;
    // Cache the stage rect; it's invalidated on mouseleave/scroll/resize so subsequent
    // mousemoves don't force a layout flush after the previous tick wrote a transform.
    const rect = this._stageRect || (this._stageRect = this.stage.getBoundingClientRect());
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    const tiltX = y * -2;
    const tiltY = x * 3;
    active.style.transform = `translateZ(0) translateX(-25%) rotateX(${tiltX}deg) rotateY(${tiltY}deg) scale(1)`;
  }

  resetTilt() {
    const active = this.slides.find(s => s.classList.contains('is-active'));
    if (!active) return;
    active.style.transform = '';
  }

  play() {
    clearInterval(this.timer);
    this.timer = setInterval(() => this.next(), this.speed);
  }

  pause() {
    clearInterval(this.timer);
  }

  handleSwipeEnd(endX, endY) {
    const dx = endX - this.swipeStartX;
    const dy = endY - this.swipeStartY;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
      if (dx < 0) this.next();
      else this.prev();
      this.play();
      if (this.swipeHint) this.swipeHint.classList.add('is-hidden');
    }
  }

  next() {
    this.current = this.getIndex(1);
    this.arrange();
  }

  prev() {
    this.current = this.getIndex(-1);
    this.arrange();
  }
}

customElements.define('clientele-slideshow', ClienteleSlideshow);

function sizeOrderKey(value) {
  const normalized = value.trim().toUpperCase();
  const clothing = normalized.replace(/[\s_-]+/g, '').replace(/EXTRA/g, 'X')
    .replace(/SMALL/g, 'S').replace(/MEDIUM/g, 'M').replace(/LARGE/g, 'L');
  if (clothing === 'S') return [0, 2];
  if (clothing === 'M') return [0, 3];
  if (clothing === 'L') return [0, 4];
  const repeated = clothing.match(/^(X+)(S|L)$/);
  if (repeated) return [0, repeated[2] === 'S' ? 2 - repeated[1].length : 4 + repeated[1].length];
  const numbered = clothing.match(/^([1-9]\d*)X(S|L)$/);
  if (numbered) return [0, numbered[2] === 'S' ? 2 - Number(numbered[1]) : 4 + Number(numbered[1])];
  const numeric = normalized.replace(/½/g, '.5').match(/^(?:(?:US|UK|EU)\s*)?(\d+(?:\.\d+)?)$/);
  if (numeric) return [1, Number(numeric[1])];
  return [normalized ? 2 : 3, 0];
}

function compareSizeValues(a, b) {
  const [aGroup, aSize] = sizeOrderKey(a);
  const [bGroup, bSize] = sizeOrderKey(b);
  return aGroup - bGroup || aSize - bSize;
}

class ProductSizeList extends HTMLElement {
  connectedCallback() {
    // Connecting also covers AJAX cards and search results. Move existing spans
    // so labels and availability styling stay intact.
    const sizes = Array.from(this.children)
      .sort((a, b) => compareSizeValues(a.textContent, b.textContent));
    if (this.hasAttribute('data-separator')) {
      this.replaceChildren(...sizes.flatMap((size, index) =>
        index ? [this.dataset.separator, size] : [size]));
    } else {
      sizes.forEach((size) => this.appendChild(size));
    }
  }
}

customElements.define('product-size-list', ProductSizeList);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    // Covers all product templates, featured products and dynamically inserted
    // quick-add pickers. Keep option positions and the selected variant intact.
    this.querySelectorAll('select').forEach((select) => {
      if (!/size/i.test(select.name)) return;
      const selected = select.value;
      Array.from(select.options).sort((a, b) => compareSizeValues(a.value, b.value))
        .forEach((option) => select.appendChild(option));
      select.value = selected;
    });

    this.querySelectorAll('fieldset').forEach((fieldset) => {
      const list = fieldset.querySelector('.variant-inline-picker__list') || fieldset;
      const radios = Array.from(list.querySelectorAll('input[type="radio"]'));
      if (!radios.length || !/size/i.test(radios[0].name)) return;
      const labels = new Map(Array.from(list.querySelectorAll('label[for]'), (label) => [label.htmlFor, label]));
      radios.sort((a, b) => compareSizeValues(a.value, b.value)).forEach((radio) => {
        list.appendChild(radio);
        const label = labels.get(radio.id);
        if (label) list.appendChild(label);
      });
    });
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    // Only match on customer-facing (visible) options. Hidden options like
    // "Unit" (a per-item inventory #) and "Condition" must NOT block matching:
    // they don't update when the shopper changes Size, so requiring them to
    // match would falsely resolve to no variant ("UNAVAILABLE"). Instead we
    // match on the visible options and let the hidden dimensions follow.
    const visibleIndexes = this.getVisibleOptionIndexes();
    const matches = this.getVariantData().filter((variant) => {
      return visibleIndexes.every((index) => this.options[index] === variant.options[index]);
    });
    // Among variants matching the visible selection, prefer an available one
    // (e.g. the in-stock Unit #), falling back to the first match otherwise.
    this.currentVariant = matches.find((variant) => variant.available) || matches[0];
  }

  // Indexes of options that render a real, customer-facing picker. Hidden
  // option containers (Unit / Condition) are excluded so they don't gate
  // matching. Works for both DOM shapes: radio pickers use <fieldset hidden>;
  // <select> pickers wrap the control in a <div ... hidden>. `this.options` is
  // built in the same source order as these controls, so indexes align.
  getVisibleOptionIndexes() {
    // VariantRadios builds options from fieldsets; VariantSelects from selects.
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const controls = fieldsets.length
      ? fieldsets
      : Array.from(this.querySelectorAll('select'));
    return controls.reduce((visible, control, index) => {
      // Hidden flag may live on the control (fieldset) or an ancestor wrapper
      // (the <select> sits inside a <div ... hidden> for internal options).
      if (!control.closest('[hidden]')) visible.push(index);
      return visible;
    }, []);
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (mediaGallery) mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${sectionId}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const condDest = document.getElementById(`condition-rating-${this.dataset.section}`);
        const condSrc = html.getElementById(`condition-rating-${sectionId}`);
        if (condSrc && condDest) condDest.innerHTML = condSrc.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      })
      .catch(() => {
        // Network/HTTP failure on variant change: don't leave the price block
        // stuck hidden. Reveal it (showing the last-rendered price) and still
        // reflect availability so the ATC button state stays correct.
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    const soldOutContact = productForm.closest('.product')?.querySelector('.sold-out-contact');

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (soldOutContact) soldOutContact.style.display = '';
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (soldOutContact) soldOutContact.style.display = 'none';
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton || !addButtonText) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checked = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return checked ? checked.value : null;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// global klaviyo form handler

let forms = document.querySelectorAll('.klaviyo-form');
for (const i of forms) {
    (function(i) {
        i.addEventListener('submit', function(e) {
            e.preventDefault();
            const url = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
            const rsp = this.querySelector('.response');
            let dtFrm = '';
            let npts = this.querySelectorAll('input');
            for (let i = 0; i < npts.length; i++) {
                dtFrm += '&' + npts[i].name + '=' + encodeURIComponent(npts[i].value);
            }
            const xhr = new XMLHttpRequest();
            xhr.open('POST', url, true);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            function showError() {
                if (!rsp) return;
                rsp.style.color = 'red';
                rsp.innerHTML = "Unknown error, please try again later.";
            }
            xhr.onload = function () {
                if (xhr.status !== 200) { showError(); return; }
                let stts;
                try {
                    stts = JSON.parse(xhr.response)["data"]["is_subscribed"];
                } catch (err) {
                    showError();
                    return;
                }
                if (stts === false) {
                    rsp.style.color = 'green';
                    rsp.innerHTML = "Thank you for signing up! Check your inbox for confirmation.";
                } else if (stts === true) {
                    rsp.style.color = 'red';
                    rsp.innerHTML = "Please use a different email address.";
                } else {
                    showError();
                }
            };
            xhr.onerror = showError;
            xhr.send(dtFrm);
        });
    })(i);
}
